import { BASE_SETTING_PRIORITIES } from 'api/digitalTwin/digitalTwinConstants'
import { useHasPermission } from 'helpers/global.helper/global.helper'
import { applySystemDisplayColors } from 'helpers/settingPriority.helper/settingPriority.helper'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'ui/components/AuthContext/AuthContext'

import DigitalTwinSettingsView from './DigitalTwinSettingsView'

export default function DigitalTwinDeviationSettingsView(): ReactElement | null {
  const { t } = useTranslation()
  const { activeSystem } = useAuth()

  const permissions = {
    canEdit: useHasPermission(`change_model_settings`),
    canEditHistoric: useHasPermission(`change_historic_model_settings`),
  }

  return (
    <DigitalTwinSettingsView
      priorities={applySystemDisplayColors(BASE_SETTING_PRIORITIES, activeSystem?.setting_priority_levels)}
      showCalendar={false}
      title={t(`Base settings`)}
      calendarTitle={t(`Base settings - calendar`)}
      tableTitle={t(`Base settings - table`)}
      isBaseSettings={true}
      permissions={permissions}
    />
  )
}
